import { render, staticRenderFns } from "./AddScanningTask.vue?vue&type=template&id=c269ff8c&"
import script from "./AddScanningTask.vue?vue&type=script&lang=js&"
export * from "./AddScanningTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports